module.exports = __webpack_public_path__ + "static/media/mainlogo.2e6600f9.svg";